import ApiUtil from '../utils/ApiUtil';
import { chartServiceUrls } from 'constants/apiEndPoints';

export const getUserChart = async (): Promise<unknown> => await
    new Promise((resolve, reject) => {
        ApiUtil.getWithToken(chartServiceUrls.userChart)
            .then((result) => {
                resolve(result);
            }).catch((error) => { reject(error); })
    });

export const getContributionChart = async (): Promise<unknown> => await
    new Promise((resolve, reject) => {
        ApiUtil.getWithToken(chartServiceUrls.contributionChart)
            .then((result) => {
                resolve(result);
            }).catch((error) => { reject(error); })
    });

export const getOrgUserChart = async (id: number): Promise<unknown> => await
    new Promise((resolve, reject) => {
        ApiUtil.getWithToken(`${chartServiceUrls.orgUserChart}/${id}`)
            .then((result) => {
                resolve(result);
            }).catch((error) => { reject(error); })
    });